import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=727756f2&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=727756f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727756f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('727756f2')) {
      api.createRecord('727756f2', component.options)
    } else {
      api.reload('727756f2', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=727756f2&scoped=true", function () {
      api.rerender('727756f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/onboarding/Item.vue"
export default component.exports